import { getStateWithOnlyOneLevel } from '../../utils/StateSelectorHelper';

function getAccountSettingsState(state) {
  return getStateWithOnlyOneLevel(state, 'manageSubscriptionReducer');
}

export const getCancelSubscriptionWaiting = (state) =>
  getAccountSettingsState(state).get('cancelSubscriptionWaiting');

export const getCancelSubscriptionSuccess = (state) =>
  getAccountSettingsState(state).get('cancelSubscriptionSuccess');

export const getCancelSubscriptionMessage = (state) =>
  getAccountSettingsState(state).get('cancelSubscriptionMessage');

export const getRevertCancellationWaiting = (state) =>
  getAccountSettingsState(state).get('revertCancellationWaiting');

export const getRevertCancellationSuccess = (state) =>
  getAccountSettingsState(state).get('revertCancellationSuccess');

export const getRevertCancellationMessage = (state) =>
  getAccountSettingsState(state).get('revertCancellationMessage');

export const getSubscriptionOperationWaiting = (state) =>
  getAccountSettingsState(state).get('subscriptionOperationWaiting');

export const getSubscriptionOperationSuccess = (state) =>
  getAccountSettingsState(state).get('subscriptionOperationSuccess');

export const getSubscriptionOperationMessage = (state) =>
  getAccountSettingsState(state).get('subscriptionOperationMessage');

export const getSubscriptionActivationWaiting = (state) =>
  getAccountSettingsState(state).get('subscriptionActivationWaiting');

export const getSubscriptionActivationSuccess = (state) =>
  getAccountSettingsState(state).get('subscriptionActivationSuccess');

export const getSubscriptionActivationMessage = (state) =>
  getAccountSettingsState(state).get('subscriptionActivationMessage');

export const getUpdateSubscriptionPlanWaiting = (state) =>
  getAccountSettingsState(state).get('updateSubscriptionPlanWaiting');

export const getUpdateSubscriptionPlanSuccess = (state) =>
  getAccountSettingsState(state).get('updateSubscriptionPlanSuccess');

export const getUpdateSubscriptionPlanMessage = (state) =>
  getAccountSettingsState(state).get('updateSubscriptionPlanMessage');

export const getRefundAmountMessage = (state) =>
  getAccountSettingsState(state).get('refundAmountMessage');
